// En premier : repli si localStorage est refusé (iframe, cookies tiers bloqués).
import './storageFallback';
import { createApp } from 'vue';
import './styles/theme.css';
import './styles/styles.css';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { useThemeStore } from './stores/themeStore';
import { initHostEmbed } from './embedHost';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { watch } from 'vue';

import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/solid.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
// Après le router : le store d'auth créé ici y a accès (useRouter).
initHostEmbed();
app.use(Vue3Toastify, {
  position: 'bottom-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: true,
  icon: true,
  rtl: false,
});

const themeStore = useThemeStore();

watch(
  () => themeStore.currentTheme,
  (newTheme) => {
    document.documentElement.setAttribute('data-theme', newTheme);
  }
);

app.mount('#app');
